import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getTranslations(language_code) {
    return axios.post(ENV.systemBase + "/translations/list_by_language_id", { language_code }, this.requestConfig());
  }

  static getAllTranslations() {
    return axios.get(ENV.systemBase + "/translations/list", this.requestConfig());
  }

  static getAllLanguages() {
    return axios.get(ENV.systemBase + "/languages/list", this.requestConfig());
  }

  static createTranslation(data) {
    return axios.post(ENV.systemBase + "/translations/create", data, this.requestConfig());
  }

  static updateTranslation(data) {
    return axios.post(ENV.systemBase + "/translations/update", data, this.requestConfig());
  }

  static deleteTranslation(requestData) {
    return axios.post(ENV.systemBase + "/translations/delete", requestData, this.requestConfig());
  }

  static generateMigration() {
    return axios.get(ENV.systemBase + "/translations/generate_migration", this.requestConfig());
  }

  static exportMissingTranslations(data) {
    return axios.post(ENV.systemBase + "/translations/export_missing_translations", data, this.requestConfig());
  }

  static importMissingTranslations(data) {
    return axios.post(ENV.systemBase + "/translations/import_missing_translations", data, this.requestConfig());
  }
}

export default Service;
